// src/components/ui/Loader.jsx
export default function Loader({ text = "Se încarcă..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-10 text-gray-600">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600 mb-3"></div>
      <p className="text-sm">{text}</p>
    </div>
  );
}
